export const Wordmark = () => null;
